import Div from '../Div';
import './logolist.scss';
import { imgUrl } from '../../helper';

const partnerLogos = [
  { src: '/images/orange.png', alt: 'Orange', category: 'telco' },
  { src: '/images/oredoo.png', alt: 'Ooredoo', category: 'telco' },
  { src: '/images/eand.png', alt: 'e&', category: 'telco' },
    { src: '/images/mtn-telco.png', alt: 'MTN', category: 'telco' },

     { src: '/images/maf.png', alt: 'Majid Al Futtaim', category: 'brand' },
    { src: '/images/partner-7.png', alt: 'Versace', category: 'other' },
  { src: '/images/tt-telco.png', alt: 'Tunisia Telecom', category: 'telco' },

    { src: '/images/zain.png', alt: 'Zain', category: 'telco' },
    { src: '/images/mobily-telco.png', alt: 'Mobily', category: 'telco' },
    { src: '/images/ethio-telco.png', alt: 'Ethio Telecom', category: 'telco' },
  
   { src: '/images/carrefour.png', alt: 'Carrefour', category: 'brand' },
    { src: '/images/stc.png', alt: 'STC', category: 'telco' },
  { src: '/images/du.png', alt: 'Du', category: 'telco' },
  { src: '/images/jazzcash.png', alt: 'Jazz', category: 'telco' },

      { src: '/images/zong-telco.png', alt: 'Zong', category: 'telco' },
  { src: '/images/onafriq.png', alt: 'Onafriq', category: 'wallet' },
  { src: '/images/payfast.png', alt: 'Payfast', category: 'wallet' },
  { src: '/images/maxit.png', alt: 'Max It', category: 'other' },
  { src: '/images/my-oreedo.png', alt: 'My Oreedoo', category: 'other' },
       { src: '/images/vox.png', alt: 'VOX Cinemas', category: 'brand' },

  { src: '/images/gamenow.png', alt: 'Game Now', category: 'other' },
  { src: '/images/myzong.png', alt: 'My Zong App', category: 'other' },
  { src: '/images/mysuperapp.png', alt: 'My Super App', category: 'other' },
     { src: '/images/foodcentral.png', alt: 'Food Central', category: 'brand' },

];

export default function LogoList({ 
  limit, 
  perRow = 4, 
  size = 120, 
  categories 
}) {

  let filteredLogos = partnerLogos;

  // ✅ Filter by multiple categories
  if (categories && categories.length > 0) {
    filteredLogos = partnerLogos.filter(
      (logo) => categories.includes(logo.category)
    );
  }

  // ✅ Apply limit (homepage use)
  const logosToShow = limit 
    ? filteredLogos.slice(0, limit) 
    : filteredLogos;

  return (
    <Div
      className="cs-partner_logo_wrap"
      style={{
        gridTemplateColumns: `repeat(${perRow}, 1fr)`,
        gap: "0px",
        alignItems: "center"
      }}
    >
      {logosToShow.map((partnerLogo, index) => (
        <div className="cs-partner_logo text-center" key={index}>
          <img
            src={imgUrl(partnerLogo.src)}
            alt={partnerLogo.alt}
            style={{ maxWidth: `${size}px`, width: '100%' }}
          />
          <div className='cs-iconbox_subtitle'>
            {partnerLogo.alt}
          </div>
        </div>
      ))}
    </Div>
  );
}